'use client'

import type { ReactNode } from 'react'

import { useIsClient } from 'hooks/useIsClient'
import { useThemeContext } from 'theme/themeProvider'

import type { svgPlaceType } from '../types'

import LogoIcon from './LogoIcon'

type Props = {
  children: ReactNode
} & svgPlaceType

export default function LogoBrandClient({ children, ...props }: Props) {
  const isClient = useIsClient()
  const { isDarkMode } = useThemeContext()

  return !isClient ? children : <LogoIcon isDarkMode={isDarkMode} {...props} />
}
